import axiosInstance from './axios';

export interface AuditLog {
  id: number;
  actorUserId: number;
  actor?: {
    id: number;
    email: string;
    role: string;
  };
  action: string;
  targetType: string;
  targetId: number | null;
  beforeData: any | null;
  afterData: any | null;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
}

export interface AuditLogsQueryParams {
  page?: number;
  pageSize?: number;
  actorUserId?: number;
  action?: string;
  targetType?: string;
  targetId?: number;
  fromDate?: string;
  toDate?: string;
}

export interface AuditLogsResponse {
  items: AuditLog[];
  page: number;
  pageSize: number;
  total: number;
}

class AuditService {
  async query(params?: AuditLogsQueryParams): Promise<AuditLogsResponse> {
    const response = await axiosInstance.get<AuditLogsResponse>('/audit-logs', { params });
    return response.data;
  }

  async getById(id: number): Promise<AuditLog> {
    const response = await axiosInstance.get<AuditLog>(`/audit-logs/${id}`);
    return response.data;
  }

  async exportCsv(params?: AuditLogsQueryParams): Promise<Blob> {
    const response = await axiosInstance.get('/audit-logs/export/csv', {
      params,
      responseType: 'blob',
    });
    return response.data;
  }
}

export const auditService = new AuditService();
